<template>
  <div style="position: relative; background: #fff;overflow: hidden; padding-bottom: 40px"
    :class="{ loadingHeight: loading }" v-loading="loading">
    <div class="lock" v-show="!editEnable || !editTable || !btnEditTable">
      <el-divider><i class="el-icon-lock lock-icon" style="
        font-size: 26px;
        color: #99a9bf;
        "></i></el-divider>
    </div>

    <div class="btnStyle">
      <el-button class="btn btn1" @click="submitForm" :disabled="noEdit" icon="el-icon-document-checked" v-if="edit">
        {{ $t("message.button.save") }}</el-button>
      <el-button :class="['btn', edit ? 'btn8' : 'btn1']" style="margin-top: 8px;" @click="editInfo"
        :disabled="!editEnable || !editTable || !btnEditTable" :icon="EditCancel.icon">
        {{ EditCancel.name }}</el-button>
    </div>
    <!-- <div style="height:45px"></div> -->
    <div v-show="!edit">
      <div style="height:240px;width:322px;background-color: #fff;position: absolute;right: 12%;top: 60px;">
        <TitleBlockImg></TitleBlockImg>
      </div>
      <div style="background: transparent;" v-for="(item, index) in pageInfo" :key="index">
        <PageShow :page="item" :pageIndex="index" :key="timeRefusr" :reset="resetNum">
        </PageShow>
      </div>
    </div>

    <el-form size="mini" ref="form" label-width="320px" v-show="edit">
      <div v-for="(item, index) in pageInfo" :key="index">
        <PageEdit :page="item" :pageIndex="index" :editNum="editNum" :change.sync="item.value" @hasChanged="editChange"
          :key="timeRefusr" :checkReq.sync="item.req">
        </PageEdit>
      </div>
    </el-form>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      // EditCancel: this.$t("message.button.edit"),
      resetNum: 0,
      timeRefusr: new Date().getTime(),

      pageInfo: [],
      edit: false,
      isClearable: true,
      editNum: 0,
      editEnable: false,
      editTable: false,
      btnEditTable: false,
      noEdit: true,
      loading: false,

      getUrl: {
        loadTable: "/ppm/project/loadTable",
        saveTable: "/ppm/project/updateProjectP1P2P3",
      },
      reqList: {},

      input_width: {
        width: "76%",
      },

      objectId: {},
      componentname: this.$route.matched[1].path.slice(1)
    };
  },
  components: {
    TitleBlockImg: () => import("../../../model/common/page/titleBlockImg.vue"),
    PageShow: () => import("./page/projectShow.vue"),
    PageEdit: () => import("./page/projectEdit.vue"),
  },
  mounted() {
    // window.addEventListener("beforeunload", this.actBeforeUnload,false);  

    window.addEventListener('mousedown', this.handleonmousedown)
  },

  //离开新增页、编辑页记得解绑，否则其他页面中也会出现提示的效果
  beforeDestroy() {
    window.removeEventListener("mousedown", this.handleonmousedown, false);
  },
  // beforeRouteLeave: function(to, from , next){
  //   this.$confirm(
  //       this.$t("message.confirm.closeAllTabs"),
  //       this.$t("message.tips.tip"),
  //       {
  //         confirmButtonText: this.$t("message.button.affirm"),
  //         cancelButtonText: this.$t("message.button.cancel"),
  //         type: "warning",
  //       }
  //     ).then(next()).catch(next(false))
  // },
  methods: {

    editInfo() {
      console.log(this.editNum);
      this.edit = !this.edit;
      if (!this.edit) {
        this.reset();
        this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
      }
      this.editNum++;
    },

    closeInfo() {
      this.edit = false;
      this.noEdit = true;
      this.reset();
    },
    editChange() {
      this.noEdit = false;
      const name = this.$route.matched[1].path.slice(1);
      this.$store.commit('setPageChanged', { name, isChanged: true });
    },

    reset() {
      this.resetNum++;
    },

    // submitForm(e) {
    //   console.log(this.manufacturerId);},
    submitForm() {
      const req = this.pageInfo.map(i => i.req);
      // console.log(req);
      for (const key in req) {
        if (!req[key] && req[key] != undefined) {
          this.$message.error(this.$t('message.warning.required'))
          return
        }
      }
      let m = this.pageInfo.map((i) => i.value);
      this.loading = true;
      axios
        .post("/ppm/project/updateProjectP1P2P3", {
          pageOne: m[0] || {},
          pageTwo: m[1] || {},
          pageThree: m[2] || {},
          objectId: this.objectId,
        })
        .then((res) => {
          //console.log(res);
          this.loading = false;
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getTitleBlockInfo();
            this.$emit("routeClick");
            this.noEdit = true;
            this.editNum = 0;
            this.edit = !this.edit;
            this.$store.commit("setReloadTabPage", true);
            this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
            !!(m[0]['1051012']) && this.replaceTabsName(m[0]['1051012'])
          }
        });
    },


    async getPages(e) {
      const { data: tabTwo } = await this.$http.get("/ppm/project/loadTable", {
        params: Object.assign({ tableId: 2 }, e),
      });
      const { data: tabThree } = await this.$http.get("/ppm/project/loadTable", {
        params: Object.assign({ tableId: 3 }, e),
      });
      return { tabTwo, tabThree }
    },
    getTitleBlockInfo() {
      // console.log(11111121212);
      let tableInfo = this.tableInfo.table;
      if (!tableInfo) {
        return
      }

      const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;

      this.loading = true;

      this.objectId = {
        ... this.$store.state.objectId,
      };

      const pagePriv = arr
        .filter((i) => i.classId == this.objectId.subClassId)
        .map((i) => i.type);

      let isSupAdmin = this.$store.state.isSuperAdmin;
      if (pagePriv.includes(3) || isSupAdmin) {
        this.editEnable = true;
      };
      this.getPages(this.objectId).then(res => {
        console.log(tableInfo);
        // console.log(res);
        this.pageInfo = [
          { column: tableInfo.columnInfo, val: tableInfo.rows[0], tableWritable: tableInfo.tableWritable, userList: this.tableInfo.userList },
          { column: res.tabTwo.object.table.columnInfo, val: res.tabTwo.object.table.rows[0], tableWritable: tableInfo.tableWritable, userList: this.tableInfo.userList },
          { column: res.tabThree.object.table.columnInfo, val: res.tabThree.object.table.rows[0], tableWritable: tableInfo.tableWritable, userList: this.tableInfo.userList },
        ];
        this.loading = false;
      });

      this.$store.commit("setItemTitleBlockImg", "isProject");

    },
    changeType(res) {
      this.$forceUpdate();
    },

  },
  mounted() {
    this.getTitleBlockInfo()
  },

  computed: {
    reloadProjectBtnPrv() {
      return this.$store.state.reloadProjectBtnDisable;
    },
    AllProjectBtnPrv() {
      return this.$store.state.AllProjectBtnDisable;
    },
    EditCancel() {
      if (!this.edit) {
        return { name: this.$t("message.button.edit"), icon: 'el-icon-edit' }
      } else {
        return { name: this.$t("message.button.cancel"), icon: 'el-icon-circle-close' }
      }
    }
  },
  props: ['reloadNewRouter', 'tableInfo'],
  watch: {
    // edit(e) {
    //   this.EditCancel = e? this.$t("message.button.cancel") : this.$t("message.button.edit")
    // },
    type: function (e) {
      console.log("tttttttt", e);
      this.pageType = e;
    },
    tableInfo: {//监听父组件的状态改变按钮，修改完状态刷新页面
      handler(val) {
        this.getTitleBlockInfo();
      },
      deep: true,
      // immediate: true,
    },
    reloadNewRouter: {//监听父组件的状态改变按钮，修改完状态刷新页面
      handler(val) {
        this.getTitleBlockInfo();
      },
      deep: true,
      // immediate: true,
    },
    reloadProjectBtnPrv: {
      handler(val) {
        this.editTable = val;
      },
      deep: true,
      immediate: true,
    },
    AllProjectBtnPrv: {
      handler(val) {
        this.btnEditTable = val;
      },
      deep: true,
      immediate: true,
    },
  },
  beforeRouteLeave(to, from, next) {
    const tabs = [...this.$store.state.showingTabsInHome];
    const activeName = this.$store.state.activedTabInHome;
    if (!this.$store.state.pageChanged) {//就是上面的状态 如果是true , 则不询问是否保存, 当然这个方法比较笨, 大家可以使用更优雅的方式
      next();
    } else {

      this.$confirm(this.$t("message.confirm.closeWithoutSave"), this.$t("message.tips.tip"), {
        confirmButtonText: this.$t("message.button.affirm"),
        cancelButtonText: this.$t("message.button.cancel"),
        type: "warning",
      })
        .then(() => {
          this.$store.commit('setPageChanged', { name: this.componentname, isChanged: false });
          next();
          if (to.path == from.matched[1].path) {
            this.$store.commit("setPageRefresh");
          }
        })
        .catch(() => {
          this.$store.commit("replaceShowingTabsInHome", tabs);
          this.$store.commit("setActivedTabInHome", activeName);
        });
    }
  },
};
</script>

<style>
ol,
ul {
  list-style: none;
}

.moneyUi .el-input-group__append {
  width: 30% !important;
}
</style>

<style scoped>
.loadingHeight {
  height: 520px;
}

.heading-edit {
  width: 100% !important;
  margin: 0 0 18px 40px;
}

.view-page2 {
  position: relative;
  overflow: hidden;
  list-style: none;
  width: 100%;
  margin-top: 20px;
  padding-left: 40px;
  padding-top: 20px;
  padding-bottom: 20px;
  background: #f4f7f9;
  background-image: url(~@/assets/titleBlock/page2.png);
  background-repeat: no-repeat;
  background-position: bottom right;
}

.view-page3 {
  position: relative;
  overflow: hidden;
  list-style: none;
  width: 100%;
  margin-top: 20px;
  padding-left: 40px;
  padding-bottom: 20px;
}

.heading {
  width: 100%;
  float: left;
  margin: 0px 0 18px 0;
}

.heading p {
  font-size: 18px;
  margin: 0;
}

.title-heading {
  width: 100%;
  float: left;
  margin: 0 0 18px -20px;
}

.title-heading p {
  font-size: 18px;
  font-weight: bold;
  margin: 0;
}

.page1 {
  width: 50%;
  overflow: hidden;
}

.page2 {
  width: 50%;
  float: left;
}

.page3 {
  width: 50%;
  float: left;
}

ul {
  margin: 0;
}

.line01 {
  border-bottom: 1px solid #cecece;
  padding: 10px 0;
}

div {
  font-size: 12px;
}

.table-list {
  height: 20px;
  overflow: hidden;
  margin-top: 4px;
}

.table-list li {
  overflow: hidden;
}

.table-list .list-key {
  display: inline-block;
  width: 42%;
  text-align: right;
  font-size: 14px;
}

.table-list .list-val {
  display: inline-block;
  width: 52%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  line-height: 18px;
  font-size: 14px;
  position: relative;
  top: 3px;
}

.table-list .list-key-1 {
  display: inline-block;
  width: 18.5%;
  text-align: right;
  font-size: 14px;
  color: #000;
}

.btnStyle {
  position: fixed;
  z-index: 999;
  right: 70px;
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
</style>
